const renderTotal = obj => Object.keys(obj).some(key => Boolean(obj[key]));

export default renderTotal;
